import React from 'react';

// Legend colors (no external dependency)
var LEGEND_ITEMS = [
  { status: 'first_come_first_serve', label: 'First Come First Serve', color: '#BDBDBD', icon: '\u2715' },
  { status: 'available', label: 'Available', color: '#4CAF50' },
  { status: 'taken', label: 'Taken', color: '#9E9E9E' },
  { status: 'temporary_taken', label: 'Temporary Taken', color: '#7B1FA2' },
  { status: 'selected', label: 'Selected', color: '#e8512f' }
];

class SeatLegend extends React.Component {
  render() {
    return (
      <div className="seat-legend">
        <div className="legend-title">Legend</div>
        {LEGEND_ITEMS.map(function(item, index) {
          return (
            <div key={index} className="legend-item">
              <div
                className={'legend-color' + (item.icon ? ' legend-color-icon' : '')}
                style={{ backgroundColor: item.color }}
              >
                {item.icon ? <span className="legend-icon">{item.icon}</span> : null}
              </div>
              <span className="legend-label">{item.label}</span>
            </div>
          );
        })}
      </div>
    );
  }
}

export default SeatLegend;
